import React from 'react';
import DashboardMain from '../components/dashboard/Dashboard';


const Dashboard = () => {
    return (<DashboardMain />)
}

export default Dashboard;